import { Outlet, createFileRoute } from "@tanstack/react-router";
import { Award03 } from "@untitled-ui/icons-react";

import TableSkeleton from "@/components/loadings/skeleton/TableSkeleton";
import type { ChildRouteContext } from "@/root";
import { redirectIfModuleDisabled } from "@/utils/permissions";

export const Route = createFileRoute("/admin/_panel/_mood")({
  component: Component,
  beforeLoad: ({ context }) => {
    redirectIfModuleDisabled("messenger", context.tenant.modules);

    return {
      title: () => context.t("Mood", { ns: "mood.shared" }),
      crumb: [
        {
          Icon: Award03,
        },
        {
          label: context.t("Mood", { ns: "mood.shared" }),
          link: { to: "/admin/mood" },
        },
      ],
    } satisfies ChildRouteContext;
  },
  pendingComponent: TableSkeleton,
});

function Component() {
  return <Outlet />;
}
